// extracted by mini-css-extract-plugin
export var bodyRow = "_ei-d";
export var cardColumns = "_ei-e";
export var ellipsesOverflow = "_ei-2";
export var flatBottomCorners = "_ei-3";
export var flatTopCorners = "_ei-4";
export var headerActionsDropdown = "_ei-f";
export var headerBottomRow = "_ei-c";
export var headerTopRow = "_ei-b";
export var orderDetailsWrapper = "_ei-0";
export var orderInfoContainer = "_ei-1";
export var productDetails = "_ei-9";
export var productImage = "_ei-5";
export var responsiveTable = "_ei-8";
export var shipmentContainer = "_ei-a";
export var tableBottomLeft = "_ei-6";
export var tableBottomRight = "_ei-7";
export var trackingLink = "_ei-g";